// extracted by mini-css-extract-plugin
export default {"root":"adc__root--bylIF","image":"adc__image--gW6nc"};